import {Table} from "semantic-ui-react";
import {Link} from "react-router-dom";
import React from "react";

export function CreditNoteListCreditNotes(props) {
    const creditNotes = props.creditNotes;

    const listCreditNotes = creditNotes.map((creditNote) =>
        <Table.Row key={creditNote.id}>
            <Table.Cell><Link to={`/credit-notes/${creditNote.id}`}>{creditNote.id}</Link></Table.Cell>
            <Table.Cell>{creditNote.creditnote_number}</Table.Cell>
            <Table.Cell>{creditNote.date}</Table.Cell>
            <Table.Cell>{creditNote.customer_name}</Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>NR</Table.HeaderCell>
                    <Table.HeaderCell>Datum</Table.HeaderCell>
                    <Table.HeaderCell>Kunde</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listCreditNotes}</Table.Body>
        </Table>
    )
}